<ng-container *ngIf="product">
    <div class="rd rd-customization fixed-top collapse h-100 show" tabindex="-1" >
        <div class="rd__cont rd__cont--customization background-color-neutral-100 h-100">

            <div class="rd__cont--customization__body pt-4">
                <div class="d-flex">
                    <div role="heading" aria-level="1" class="heading-s-b rd__cont--customization__title">Customize</div>
                </div>
                <div class="customize-product d-flex flex-column flex-sm-row">
                    <div class="align-self-center mb-3 mb-sm-0">
                        <img class="customize-product__img" [attr.src]="product.imageUrl + '?$grid-product-card-mobile$&defaultImage=Not_Available'" alt="{{ product.name }}">
                    </div>
                    <div class="customize-product__info-section">
                        <div role="heading" aria-level="2" class="heading-s mb-2">{{ product.name }}</div>
                        <p class="text-m customize-product__info-section__desc mb-0">{{ productDescription }}</p>
                    </div>
                </div>
                <hr class="rd__cont--customization__divider">
                <ng-container *ngFor="let modifier of product['modifiers']; index as modIndex">
                    <div *ngIf="modifier?.options?.length" class="customize-selection" [ngClass]="{'mt-0': modIndex === 0 }">
                        <div id="{{ modifier.name + 'Options' }}" role="heading" aria-level="2" class="title-sm font-weight-bold">{{
                            modifier.name }}</div>
                        <div class="mt-2 mb-0">
                            <div class="d-flex align-items-center">
                                <span
                                    *ngIf="modifier.minSelect >= 1 && isMinSelectSatisfied(modifier)"
                                    aria-hidden="true"
                                    class="svg-icon svg-checkedSucces customize-selection__icon--success mr-1"></span>
                                <span
                                    *ngIf="modifier.minSelect >= 1 && !isMinSelectSatisfied(modifier)"
                                    aria-hidden="true" class="svg-icon svg-caution customize-selection__icon mr-1">
                                </span>
                                <span aria-hidden="true" *ngIf="( (modifier.minSelect && modifier.maxSelect) && (modifier.minSelect > 0 && modifier.maxSelect > 0) && (modifier.minSelect === modifier.maxSelect) ) ||
                                    ((modifier.minSelect && modifier.maxSelect) && (modifier.minSelect !== modifier.maxSelect) && (modifier.minSelect >= 1 && modifier.maxSelect > 1)) ||
                                    (modifier.minSelect === 1 && !modifier.maxSelect)" 
                                    class="body-text-sm"
                                    [ngClass]="{'customize-selection__require-text': modifier.minSelect >= 1 && !isMinSelectSatisfied(modifier), 'customize-selection__require-text--success': modifier.minSelect >= 1 && isMinSelectSatisfied(modifier) }">
                                    Required
                                </span>

                                <span *ngIf="(!modifier.minSelect && !modifier.maxSelect) || ((!modifier.minSelect || modifier.minSelect === 0) && modifier.maxSelect >= 1)" class="body-text-sm customize-selection__select-text" aria-hidden="true">Optional</span>
                                <span *ngIf="!(!modifier.minSelect && !modifier.maxSelect)" aria-hidden="true" class="svg-icon svg-bullet-dot customize-selection__bullet-dot"></span>

                                <span class="body-text-sm customize-selection__select-text" aria-hidden="true">
                                    <span *ngIf="(modifier.minSelect && modifier.maxSelect) && (modifier.minSelect > 0 && modifier.maxSelect > 0) && (modifier.minSelect === modifier.maxSelect)">Select
                                        <span data-qa="cstm_slct_min_cnt"> {{ modifier.minSelect }}</span>
                                    </span>
                                    <span *ngIf="((modifier.minSelect && modifier.maxSelect) && (modifier.minSelect !== modifier.maxSelect) && (modifier.minSelect >= 1 && modifier.maxSelect > 1)) ||
                                    (modifier.minSelect === 1 && !modifier.maxSelect)">Select at least
                                        <span data-qa="cstm_slct_min_cnt">{{ modifier.minSelect }}</span>
                                        <span *ngIf="!(modifier.minSelect === 1 && !modifier.maxSelect)">, max</span>
                                        <span *ngIf="!(modifier.minSelect === 1 && !modifier.maxSelect)" data-qa="cstm_slct_max_cnt"> {{ modifier.maxSelect }}</span>
                                    </span>
                                    <span *ngIf="(!modifier.minSelect || modifier.minSelect === 0) && modifier.maxSelect >= 1">Select up to
                                        <span data-qa="cstm_slct_max_cnt"> {{ modifier.maxSelect }}</span>
                                    </span>
                                </span>

                                <span class="sr-only" aria-hidden="false">
                                    <span *ngIf="modifier.minSelect >= 1 && isMinSelectSatisfied(modifier)">Selected.</span>
                                    <span *ngIf="modifier.minSelect >= 1 && !isMinSelectSatisfied(modifier)">Caution.</span>
                                    <span *ngIf="(modifier.minSelect && modifier.maxSelect) && (modifier.minSelect > 0 && modifier.maxSelect > 0) && (modifier.minSelect === modifier.maxSelect)">
                                        Required. Select {{ modifier.maxSelect }}
                                    </span>
                                    <span *ngIf="(modifier.minSelect && modifier.maxSelect) && (modifier.minSelect !== modifier.maxSelect) && (modifier.minSelect >= 1 && modifier.maxSelect > 1)">
                                        Required. Select at least {{ modifier.minSelect }}, maximum {{ modifier.maxSelect }}
                                    </span>
                                    <span *ngIf="(!modifier.minSelect || modifier.minSelect === 0) && modifier.maxSelect >= 1">
                                        Optional. Select up to {{ modifier.maxSelect }}
                                    </span>
                                    <span *ngIf="modifier.minSelect === 1 && !modifier.maxSelect">
                                        Required. Select at least {{ modifier.minSelect }}
                                    </span>
                                    <span *ngIf="(!modifier.minSelect && !modifier.maxSelect) || (modifier.minSelect === 0 && modifier.maxSelect === 0)">
                                        Optional
                                    </span>
                                </span>
                            </div>
                        </div>
                        <div role="group" [attr.aria-labelledby]="modifier.name + 'Options'"
                            class="customize-selection__options mt-4 m-0 row m-0 mb-3">
                            <ng-container *ngFor="let option of modifier.options; index as i">
                                <ng-container *ngTemplateOutlet="
                                                  optionTemplate;
                                                  context: { modifier: modifier, option: option, index: i }
                                              "></ng-container>
                            </ng-container>
                        </div>
                    </div>
                </ng-container>
                <div class="customize-selection">
                    <div role="heading" aria-level="2" class="title-sm font-weight-bold">Preferences</div>
                    <div class="mt-2 mb-0">
                        <label for="specialInstructions" class="body-text-sm align-middle customize-selection__select-text">Optional</label>
                    </div>
                    <div class="pds-input-field-group mt-4 m-0">
                        <textarea #preferencesTextArea [value]="preferencesText" (input)="updateChar(preferencesTextArea.value)" id="specialInstructions" class="pds-input-field-form-control pds-input-field-textarea" maxlength="120" placeholder="Add note here" aria-label="Preferences, optional multiline"></textarea>
                        <label
                            class="text-l pds-input-field-group--label pds-input-field-textarea" [ngClass]="{'pds-input-field-group--label__error': preferencesText.length === 120}"
                            for="specialInstructions">Add note here</label>
                        <div class="pds-input-field-error-group d-flex mt-1" *ngIf="preferencesText.length === 120">
                            <span class="pds-svg-error-icon float-left ml-3 mr-1"></span>
                            <span class="text-s pds-input-field-error-message">Maximum character limit reached</span>
                        </div>
                        <span class="pds-input-field-counter float-right mt-1 mr-3 text-s" aria-hidden="true">
                            {{ preferencesText.length }}/120
                        </span>
                        <span aria-live="polite" class="sr-only">
                            {{ preferencesText.length }} out of 120 characters used
                        </span>
                    </div>
                </div>
            </div>
            <div class="pt-3 pb-4 px-4 rd__cont--customization__footer">
                <div>
                    <span class="body-text rd__cont--customization__footer__est-text">Estimated total</span>
                    <span class="body-text font-weight-bold float-right rd__cont--customization__footer__price">{{ estimatedPrice | currency: 'USD' }}</span>
                </div>
                <div class="d-flex justify-content-between mt-3 rd__cont--customization__footer__btn-container">
                    <quantity-stepper-al-v2 [product]="clonedProduct"
                                            [configObj]="configObj"
                                            [calledBy]="'qtyStepperExpand'"
                                            [qtyStepperOptions]="qtyStepperOptions"
                                            class="w-100"
                                            (qtyStepperExpandEmitter)="getUpdatedQty($event)">
                    </quantity-stepper-al-v2>
                    <quantity-stepper-al-v2 [product]="product"
                                            [configObj]="configObj"
                                            [calledBy]="'customize-drawer'"
                                            [qtyStepperOptions]="qtyStepperOptions"
                                            (qtyStepperInfoEmitter)="scrollToFirstMissingCustomization()"
                                            class="w-100">
                    </quantity-stepper-al-v2>
                </div>
            </div>

        </div>
    </div>
</ng-container>

<!-- Customize Option template-->
<ng-template #optionTemplate let-isOOS="option.isOOS" let-modifier="modifier" let-option="option" let-index="index">


    <label
  class="col-12 col-md-6 mb-0 d-block p-0 customize-selection__options__label"
  [ngClass]="{ 'mr-3': 0 === index % 2 }"
  [attr.for]="modifier.name + 'Option' + index">
  <input
    [disabled]="isOOS || (modifier.controlType !== 'radio' && modifier.maxSelect && !option.isSelected && getTotalSelectedQtyForModifier(modifier))"
    [checked]="option.isSelected"
    class="m-0 p-0"
    [attr.aria-checked]="option.isSelected"
    type="{{ modifier.controlType === 'radio' ? 'radio' : 'checkbox' }}"
    (change)="onOptionSelect(modifier, option, $event)"
    [attr.name]="modifier.name + 'Options'"
    [attr.id]="modifier.name + 'Option' + index"
    [attr.data-upc-id]="option.upcId"
    [attr.aria-label]="getOptionAriaLabel(modifier, option, index, isOOS)"
  />

  <span
    class="customize-selection__options__opt d-flex align-items-center"
    [ngClass]="{ 'customize-selection__options__opt--oos': isOOS || (modifier.controlType !== 'radio' && modifier.maxSelect && !option.isSelected && getTotalSelectedQtyForModifier(modifier))}">
    <span class="text-l customize-selection__options__opt__value" aria-hidden="true">{{ option.name }}</span>
    <span *ngIf="option.baseCalories" class="text-s ml-2 customize-selection__options__opt__cal" aria-hidden="true">{{ option.baseCalories }}&nbsp;cal</span>
    <span *ngIf="option.temperature?.toLowerCase() === 'hot'" class="text-l-sb--info ml-2" aria-hidden="true">(not SNAP eligible)</span>
    <span *ngIf="modifier.stepperEnabled && option.isSelected && isCateringEnabled && modifier.maxSelect !== 1 && !(option.name?.startsWith('No'))">
        <quantity-stepper-simple-al-v1 [modifier]="modifier"
                                    [option]="option"
                                    class="ml-auto"
                                    (qtyStepperInfoEmitter)="handleQuantityChange(modifier, option, $event)">
        </quantity-stepper-simple-al-v1>
    </span>
    <span *ngIf="isOOS" class="text-s-sb ml-2 customize-selection__options__opt__oos-msg" aria-hidden="true">Out&nbsp;of&nbsp;stock</span>
    <!-- price: show computed total when catering enabled, otherwise show base price -->
    <span *ngIf="option.price" class="body-text ml-auto pl-2 customize-selection__options__opt__price" aria-hidden="true">
      +{{ getOptionPriceDisplay(option) }}
    </span>
  </span>
</label>

</ng-template>

